define( 'components/m12-masthead/m12-masthead-mobile-menu',[
	'jquery',
	'breakpoint',
	'lib/utils',
	'mask',
	'components/_helpers/touch-scroller/touch-scroller',
	'text!components/m12-masthead/_m12-masthead-mobile-menu.hbs',
	 ],

	function ( $, breakpoint, utils, Mask, TouchScroller, mobileMenuPartial ) {

		'use strict';

		var MobileMenu = function () {

				this.initialized = false;
			},
			_singleton;

		MobileMenu.prototype.init = function ( $masthead ) {

			if ( !this.initialized ) {
				var _this = this;

				this.done = false;
				// cache masthead dom els
				this.$masthead = $masthead;
				this.$segmentNav = this.$masthead.find( '[data-segment-nav]' );
				this.$segmentLinks = this.$masthead.find( '[data-segment-link]' );
				this.$sectionNavs = this.$masthead.find( '[data-section-nav]' );
				this.$accessibilityContent = this.$masthead.find( '[data-accessibility-content]' );
				this.$myAccountLink = this.$masthead.find( '.m12-myaccount__link[data-m12-myaccount-link]' );
				this.$myAccountLogoutLink = this.$masthead.find( '[data-myaccount-logout]' );
				this.$myAccountPostLoginNav = this.$masthead.find( '[data-myaccount-postlogin-nav]' );
				this.$languageLink = this.$masthead.find( '[data-m12-lang-link]' );
				this.$barContent = this.$masthead.find( '[data-m12-bar-content]' );
				this.$menuButton = $( '<button class="m12-mobile-menu-button" data-menu-button="true"><div class="m12-menu_expandable m12-menu_expandable--mobile"><div class="m12-menu_bar--wrapper"><span class="top-bar"></span><span class="mid-bar"></span><span class="bot-bar"></span></div><label class="m12-menu_label">'+$('.m12-section-navs').find('.m12-menu_label').html()+'</label></div></button>' );
				//this.$closeButton = $( '<button class="mobile-menu-closebtn" data-mobile-menu-close-button="true"></button>' );
				this.$searchContent = this.$masthead.find( '[data-search]' );

				// general props
				this.mobileMenuActiveClassname = 'mobile-menu--active';
				this.mobielMenuActiveCloseClassname = 'mobile-menu-closebtn--active';
				this.mobileMenuAccessibilityClassname = 'mobile-menu--accessibility-open';
				this.labels = $masthead.data( 'labels' );
				this.theme = $masthead.data( 'theme' );
				this.isSAP = $masthead.data( 'sap' ) === true;
				this.open = false;
				this.maxWidth = 440;

				// add the mobile menu to dom
				this.addMenu();

				// cache dom els from above
				this.$mobileMenu = $( '[data-mobile-menu="true"]' );
				this.$accessibilityPanel = this.$mobileMenu.find( '[data-mobile-accessibility-panel]' );
				this.$languageLinkContainer = this.$mobileMenu.find( '[data-language-link]' );
				this.$searchPanel = this.$mobileMenu.find( '[data-mobile-search-panel]' );
				this.$accessibilityMobileContent = this.$mobileMenu.find( '[data-mobile-menu-accessibility]' );
				this.$accessibilityHeader = this.$mobileMenu.find( '[data-mobile-menu-accessibility-header]' );
				// this.$myAccount = this.$mobileMenu.find( '[data-mobile-menu-myaccount]' );
				this.$accessibilityButton = this.$mobileMenu.find( '[data-accessibility-button]' );
				this.$o4Button = this.$mobileMenu.find('[data-o4-button]');
				//this.$searchButton = this.$mobileMenu.find( '[data-search-button]' );
				this.$header = this.$mobileMenu.find( '[data-mobile-menu-header]' );

				// other props
				// this.postLogin = this.$myAccountPostLoginNav.length > 0;

				// search field el
				this.$searchField = this.$mobileMenu.find( '[data-search-field]' );

				// bind global el events
				//this.$menuButton.on( 'click', $.proxy( this.openMenu, this ) );
				this.$menuButton.on('click', function (event) {
					if ($(this).find('.m12-menu_bar--wrapper').hasClass('active')) {
						_this.closeMenu();
					} else {
						_this.openMenu(event);
					}
				});
				$('.mobile-menu--close_tabletbtn').on('click', function () {
					_this.closeMenu();
				});
				//this.$closeButton.on( 'click', $.proxy( this.closeMenu, this ) );
				this.$accessibilityHeader.text($('.m27-accessibility-overlay__title').text());
				this.$accessibilityHeader.on( 'click', $.proxy( this.toggleAccessibilityPanel, this ) );
				this.$accessibilityButton.on( 'click', $.proxy( this.toggleAccessibilityPanel, this ) );

				this.$o4Button.find('img').attr('src', $('.m13-footer--floating_link--o4').find('img').attr('src'));
				this.$o4Button.on('click', function(){
					$('.m13-footer--floating_link--o4').trigger('click');
				});
				//this.$searchButton.on( 'click', $.proxy( this.openSearch, this ) );

				$(window).off('searchOpen').on('searchOpen', function () {
					_this.openSearch();
				});

				this.buildMenu();
				this.buildFooter();

				// bind window events
				$( window ).on( 'orientationchange resize', $.proxy( this.setStyle, this ) );

				$( breakpoint ).on( 'change', $.proxy( this.respond, this ) );

				// set initialized flag
				this.initialized = true;

				// popup modal switch language 
				//$('.m12-tools__link--lang').on('click', function (event) {
				//	var defRef = $(this).attr('href');

				//	event.preventDefault();
				//	$('.mobile-menu-closebtn').trigger('click');
				//	$('.m39-modal__triggerLang').trigger('click');
				//	$('.m39-m12-yes').attr('href', defRef)
				//});

				var home_link = $('.m12-section-nav').find('.m12-segment-nav__link--Home').attr('href');

				$('.mobile-menu__myaccount').find('.m12-segment-nav__link--Home').attr('href', home_link);

				$('.mobile-menu-navs .m12-menuover-main').css('max-height', 'calc(100% - '+(100 + $('.mobile-menu__header').outerHeight(true))+'px)');

				$('[data-mobile-menu-footer] img').not('[data-o4-button] img').attr('src', $('.m12-logo-image--government').attr('data-defaultsrc'));

				$('.m13-footer--floating_linkmobile-hide').not('.m13-footer--floating_link--o4, .m13-footer--floating_link--ai').each(function () {
					$('.m12-menuover-main').append('<a class="m12-menuover-main_item m12-menuover-main_itemlink" href="'+$(this).attr('href')+'">'+$(this).text()+'</a>')
				});

				$('.m12-quicklinks--mobiletitle').text(this.labels.quicklinks);

				$('.mobile-menu-navstitle').text(this.labels.mainmenu);

				// if ($('.m12-myaccount__link--logout').length != 0) {
				// 	var lClone = $('.m12-myaccount__link--logout').clone();

				// 	_this.$myAccount.after(lClone);
				// };

				$(window).off('mhaTR').on('mhaTR', function() {
					_this.buildMenuListeners();
				});

			};

		};

		/**
		 * Adds the menu to the dom from a mustache template. 
		 */
		MobileMenu.prototype.addMenu = function () {

			// var mobileMenuTemplate = Mustache.render( mobileMenuPartial, {
			// 	is_sap: this.isSAP
			// } );

			// console.log(mobileMenuPartial)

			// add menu button
			this.$barContent.prepend( this.$menuButton );
			this.$menuButton.find('.m12-menu_label').text( this.labels.menu );

			// add menu template
			$( 'body' ).append( mobileMenuPartial );

			// add close button
			//$( '.mobile-menu' ).append( $( this.$closeButton ) );
			//this.$closeButton.attr( 'aria-label', this.labels.close );
			//this.$closeButton.html( this.labels.close );

		};

		MobileMenu.prototype.loadScrollers = function () {

			this.level1Scroller = new TouchScroller();
			this.level1Scroller.init( this.$level1Nav.parent() );

			this.level2Scroller = new TouchScroller();
			this.level2Scroller.init( this.$level2Nav.parent() );

			this.level3Scroller = new TouchScroller();
			this.level3Scroller.init( this.$level3Nav.parent() );

			this.$accessibilityPanel.parent().addClass( 'scroll' );
			
		};

		MobileMenu.prototype.buildMenu = function () {
			var _this = this,
				$desktopc = $('.m12-menuover-content'),
				$mainclone = $('.m12-menuover-main').clone();

			$('.mobile-menu-navs').append($mainclone);

			$('.mobile-menu-navs').find('.m12-menuover-main_item').each(function() {
				var $main = $(this),
					call = $(this).attr('data-call');

				//$main.removeClass('m12-menuover-main_itemactive');
				$main.html('<label class="m12-menuover-main_item--label">'+$main.text()+'</label>');

				$desktopc.find('.m12-menuover-2').find('.m12-menuover-primary').each(function() {
					var tag = $(this).attr('data-tag'),
						$clone = $(this).clone();

					if ( call == tag ) {
						$main.append($clone);
					};
				});
			});

			$('.mobile-menu-navs').find('.m12-menuover-primary_item').each(function() {
				var $primary = $(this),
					call = $(this).attr('data-call');

				//$primary.removeClass('m12-menuover-primary_itemactive');
				$primary.html('<label class="m12-menuover-primary_item--label">'+$primary.text()+'</label>');

				$desktopc.find('.m12-menuover-3').find('.m12-menuover-secondary').each(function() {
					var tag = $(this).attr('data-tag'),
						$clone = $(this).clone();

					//$(this).removeClass('m12-menuover-secondaryactive');

					if ( call == tag ) {
						$primary.append($clone);
					};
				});
			});

			if (this.$languageLink.length != 0) {
				this.$languageLinkContainer.html(this.$languageLink.html());
				this.$languageLinkContainer.attr('href', this.$languageLink.attr('href'));
			} else {
				this.$languageLinkContainer.hide();
			}

			// this.$myAccount.append(this.$myAccountLink.clone());
			// this.$myAccount.attr('href', this.$myAccountLink.attr('href'));
			// this.$myAccount.attr('class', this.$myAccountLink.attr('class'));
			// this.$myAccount.removeClass('m12-myaccount__link');
			// this.$myAccount.removeClass('icon-new-myaccount');
			// this.$myAccount.removeClass('button--outline');
			// this.$myAccount.addClass('mobile-menu__tool-button--myaccount');
			// this.$myAccount.addClass('mobile-menu__tool-button');
			// this.$myAccount.addClass('button--primary');

			// add accessibility panel
			if ( this.$accessibilityContent[ 0 ] !== undefined ) {

				var aPanel = this.$accessibilityContent.clone( true );
				aPanel.find('#xp1').attr('id', 'xp2');
				aPanel.find('a.readspeaker-link').attr('onclick', 'readpage(this.href, \'xp2\'); return false;');
				this.$accessibilityPanel.append( aPanel );
			};
			
			// add search
			this.$searchPanel.append( this.$searchContent.clone( true ) );
			this.$searchPanel.find('#searchcategory').attr('class', 'mobile--searchcategory');

			this.buildMenuListeners();

			setTimeout(function() {
				$('.mobile-menu-navs').find('.m12-menuover-main_itemactive').find('.m12-menuover-main_item--label').click();
				$('.mobile-menu-navs').find('.m12-menuover-primary_itemactive').find('.m12-menuover-primary_item--label').click();
			},250);
		};

		MobileMenu.prototype.calcLabelHeights = function () {
				$('.mobile-menu-navs').find('.m12-menuover-main_item').each(function() {
					var $main = $(this);

					$main.find('.m12-menuover-main_item--label').each(function() {
						var labelHeight = $main.find('.m12-menuover-main_item--label').outerHeight(true),
							height = $main.find('.m12-menuover-primary').height() + labelHeight;

						if ( $main.hasClass('m12-menuover-main_itemactive-mobile') ) {
							$main.css('height', height.toString() + 'px');
						} else {
							$main.css('height', labelHeight);
						};
					});
				});
			

				// $('.mobile-menu-navs').find('.m12-menuover-primary_item').each(function() {
				// 	var $primary = $(this),
				// 		labelHeight = $primary.find('.m12-menuover-primary_item--label').outerHeight(true);

				// 	// $primary.css('height', labelHeight);

				// 	$primary.find('.m12-menuover-primary_item--label').each(function() {
				// 		var height = $primary.find('.m12-menuover-secondary').height(),
				// 			$parentheight = $(this).closest('.m12-menuover-main_item').outerHeight(true);

				// 		//$parentheight =  $parentheight - $('.m12-menuover-primary_itemactive-mobile').height();

				// 		$('.mobile-menu-navs').find('.m12-menuover-primary_item').each(function() {
				// 			// $(this).not($primary).css('height', labelHeight);
				// 			//$parentheight = $primary.closest('.m12-menuover-primary').height() + 42;
				// 		});

				// 		if ( $primary.hasClass('m12-menuover-primary_itemactive-mobile') ) {
				// 			$primary.css('height', labelHeight);
				// 			$primary.closest('.m12-menuover-main_item').css('height', ($parentheight-height).toString() + 'px');
				// 		} else {
				// 			$parentheight = ($(this).closest('.m12-menuover-main_item').find('.m12-menuover-primary_item').length * labelHeight) + 50;
				// 			$primary.css('height', (height+labelHeight).toString() + 'px');
				// 			$primary.closest('.m12-menuover-main_item').css('height', (height + $parentheight).toString() + 'px');
				// 		};
				// 	});
				// });
		
		};

		MobileMenu.prototype.buildMenuListeners = function () {
			var _this = this;

			$('.mobile-menu-navs').find('.m12-menuover-primary_item').each(function() {
				var $primary = $(this),
					height1 = $primary.find('.m12-menuover-secondary').height(),
					labelHeight = $primary.find('.m12-menuover-primary_item--label').outerHeight(true);

				if ( !$primary.hasClass('m12-menuover-primary_itemactive-mobile') ) {
					$primary.css('height', labelHeight);
				} else {
					// $primary.css('height', labelHeight + $primary.find('.m12-menuover-secondary').height());
				}

				$primary.find('.m12-menuover-primary_item--label').off('click.mm12').on('click.mm12', function() {
					var height = $primary.find('.m12-menuover-secondary').height(),
						$parentheight = $(this).closest('.m12-menuover-main_item').outerHeight(true);

					//$parentheight =  $parentheight - $('.m12-menuover-primary_itemactive-mobile').height();

					$('.mobile-menu-navs').find('.m12-menuover-primary_item').each(function() {
						$(this).not($primary).css('height', labelHeight);
						$(this).not($primary).removeClass('m12-menuover-primary_itemactive');
						$(this).not($primary).removeClass('m12-menuover-primary_itemactive-mobile');
						//$parentheight = $primary.closest('.m12-menuover-primary').height() + 42;
					});

					// setTimeout(function() {
						if ( $primary.hasClass('m12-menuover-primary_itemactive-mobile') ) {
							$primary.removeClass('m12-menuover-primary_itemactive');
							$primary.removeClass('m12-menuover-primary_itemactive-mobile');
							$primary.css('height', labelHeight);
							$primary.closest('.m12-menuover-main_item').css('height', ($parentheight-height).toString() + 'px');
						} else {
							$parentheight = ($(this).closest('.m12-menuover-main_item').find('.m12-menuover-primary_item').length * labelHeight) + 50;
							$primary.css('height', (height+labelHeight).toString() + 'px');
							$primary.closest('.m12-menuover-main_item').css('height', (height + $parentheight).toString() + 'px');
							$primary.addClass('m12-menuover-primary_itemactive');
							$primary.addClass('m12-menuover-primary_itemactive-mobile');
						}
					// }, 125);
				});
			});

			$('.mobile-menu-navs').find('.m12-menuover-main_item').each(function() {
				var $main = $(this);

				if ( !$main.hasClass('m12-menuover-main_itemactive-mobile') ) {
					$main.css('height', $main.find('.m12-menuover-main_item--label').outerHeight(true));
				} else {
					$main.css('height', $main.find('.m12-menuover-primary').height() + $main.find('.m12-menuover-main_item--label').outerHeight(true));
				};

				$main.find('.m12-menuover-main_item--label').off('click.mm12').on('click.mm12', function() {
					var labelHeight = $main.find('.m12-menuover-main_item--label').outerHeight(true),
						height = $main.find('.m12-menuover-primary').height() + labelHeight;

					$('.mobile-menu-navs').find('.m12-menuover-main_item').each(function() {
						$(this).not($main).css('height', labelHeight);	
						$(this).not($main).removeClass('m12-menuover-main_itemactive');
						$(this).not($main).removeClass('m12-menuover-main_itemactive-mobile');
					});

					// setTimeout(function() {
						if ( $main.hasClass('m12-menuover-main_itemactive-mobile') ) {
							$main.removeClass('m12-menuover-main_itemactive');
							$main.removeClass('m12-menuover-main_itemactive-mobile');
							$main.css('height', labelHeight);
						} else {
							$main.css('height', height.toString() + 'px');
							$main.addClass('m12-menuover-main_itemactive');
							$main.addClass('m12-menuover-main_itemactive-mobile');
						};
					// }, 125);
				});
			});

			$('.mobile-menu__tool-button--myaccount').off('click.dynamic').on('click.dynamic', function(event) {
				var href = $('.m12-menuover-main_itemactive-mobile').attr('data-loginhref')
				if ( href != undefined && href != "") {
					event.preventDefault();
					window.location.href = href;
				}
			});
		};

		MobileMenu.prototype.buildFooter = function () {
			var _this = this;

			$('.m12-quicklinks').find('.m12-quicklinks-item').each(function() {
				$('.m12-quicklinks--mobile').append($(this).clone())
			});
		};

		MobileMenu.prototype.openMenu = function ( e ) {
			var _this = this;

			e.stopImmediatePropagation();
			var self = this;
			this.open = true;
			Mask.show();
			this.$mobileMenu.addClass( 'theme--' + this.theme ).addClass( this.mobileMenuActiveClassname );
			//this.$closeButton.addClass( this.mobielMenuActiveCloseClassname );
			$( 'body' ).addClass( 'unscrollable' );
			$( 'body' ).css( 'position','static' );
			this.setStyle();
			_this.$masthead.find('.m12-menu_expandable--mobile .m12-menu_bar--wrapper').addClass('active');

			// prevent any bouncy effects on the mobile menu
			$( document ).on( 'touchmove', function ( e ) {

				if ( $( e.target ).parents( '[data-mobile-accessibility-panel]' )[ 0 ] === undefined ) {
					
					e.preventDefault();
				}
			} );

			$( Mask.$el ).on( 'click', function ( e ) {

				if ( $( e.target ).parents( '[data-mobile-menu]' )[ 0 ] === undefined ) {

					self.closeMenu();
				}
			} );

			if ( $('.mobile-menu').hasClass('theme--c') && !_this.done ) {
				$('.mobile-menu').find('.m12-section-nav[data-mobile-menu-level1-nav=true]').append('<li class="m12-segment-nav__item"><a class="m12-segment-nav__link--c" href="'+$('.m12-section-nav__item:last-child').find('.m12-section-nav__link ').attr('href')+'">'+$('.m12-section-nav__item:last-child').find('.m12-section-nav__link ').text()+'</a></li>');
				_this.done = true;
			};

		};

		MobileMenu.prototype.closeMenu = function () {
			var _this = this;

			if ( this.initialized ) {

				this.open = false;
				this.closeSearch();
				Mask.hide();
				this.$mobileMenu.removeClass().addClass( 'mobile-menu' );
				//this.$closeButton.removeClass( this.mobielMenuActiveCloseClassname );
				$( 'body' ).removeClass( 'unscrollable' );
				$( document ).off( 'touchmove' );
				$( Mask.$el ).off( 'click' );
				_this.$masthead.find('.m12-menu_expandable--mobile .m12-menu_bar--wrapper').removeClass('active');
			}
		};

		MobileMenu.prototype.toggleAccessibilityPanel = function () {

			this.$mobileMenu.toggleClass( this.mobileMenuAccessibilityClassname );

		};

		MobileMenu.prototype.openSearch = function () {

			var self = this;

			this.$header.hide();

			this.$searchPanel.addClass( 'mobile-menu-search--active' );

			this.$searchPanel.find( 'input[type=search]' ).focus();

			$('.m12-search__panel--close').on( 'click', function () {

				setTimeout( function () {

					self.closeSearch();
					window.scrollTo( 0, 0 );
				}, 150 );

			} );

			this.$searchPanel.on( 'click', function ( e ) {

				if ( $( e.target ).parents( '[data-search]' )[ 0 ] === undefined ) {
					self.closeSearch();
				}
			} );

		};

		MobileMenu.prototype.closeSearch = function () {

			this.$header.show();

			this.$searchPanel.removeClass( 'mobile-menu-search--active' );

			this.$searchPanel.off( 'click' );

			setTimeout( function () {

				$( document ).scrollTop( $( document ).scrollTop() );
			}, 1 );
		};

		MobileMenu.prototype.setStyle = function () {

			var windowWidth = $( window ).width(),
				width = $( window ).width() > this.maxWidth ? this.maxWidth : windowWidth;

			this.$mobileMenu.css( 'width', width);

		};

		MobileMenu.prototype.respond = function () {

			if ( utils.breakpoint() === 'l' || utils.breakpoint() === 'xl' ) {

				this.closeMenu();

			}
		};


		_singleton = new MobileMenu();

		return _singleton;
	} );

